
import request from './request';
import * as endpoints from './api-endpoint'

export function getConversations(pageNumber) {
  return request.get(endpoints.conversations(pageNumber));
}